import React from "react";
import * as Icons from "react-feather";

function WarningAlert(props) {
    return (
        <>
            <div className="col-xl-3 sweetalert">
                <div className="card border-0">
                    <div className="alert alert-warning border border-warning mb-0 p-3">
                        <div className="d-flex align-items-start">
                            <div className="me-2">
                                <Icons.AlertTriangle className="flex-shrink-0" />
                            </div>
                            <div className="text-warning w-100">
                                <div className="fw-semibold d-flex justify-content-between">Warning Alert</div>
                                <div className="fs-12 op-8 mb-1">{props.alert.message}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WarningAlert;
